// extracted by mini-css-extract-plugin
module.exports = {"root":"AvailableBalance_root__z_3Bv"};